import axios from 'axios'
import { get, post, del } from '@/http/request'
import { HOST } from '@/http/config'

// 费用报销申请
export function expenseReimbursementList(params) {
  return get(`${HOST}expense-reimbursement/expenseReimbursementList`, params)
}
// 费用报销草稿箱
export function expenseReimbursementDraftList(params) {
  return get(`${HOST}expense-reimbursement/expenseReimbursementDraftList`, params)
}
// 详情  
export function expenseReimbursementGet(params) {
  return get(`${HOST}expense-reimbursement/expenseReimbursementGet/${params}`)
}
// 根据id删除
export function deleteClaimExpense(params) {
  return del(`${HOST}expense-reimbursement/expenseReimbursementDelete/${params}`)
}
// 申请费用报销
export function addClaimExpenseApi(params) {
  return post(`${HOST}expense-reimbursement/expenseReimbursementSave`, params)
}
// 根据id修改
export function expenseReimbursementUpdate(params, id) {
  return post(`${HOST}expense-reimbursement/expenseReimbursementUpdate/${id}`, params)
}
//收款资料表
export function sysCollection(params) {
  return get(`${HOST}sys-collection/list`, params)
}
//自己收款资料
export function myCollection(params) {
  return get(`${HOST}sys-collection/getList`, params)
}



// WEBPACK FOOTER //
// ./src/views/ClaimExpense/api/api.js